// Telegram links open the app directly on desktop instead of bouncing
// through t.me (2026-09-07). Some Thai ISPs hijack t.me's DNS (the operator's
// resolves to 125.26.170.3 and the connection hangs), so Telegram's landing
// page — the thing that normally hands off to the app — never loads and the
// tap looks dead. `tg://resolve?domain=<handle>` needs no network at all;
// every query parameter (`?text=` draft, `?start=` bot payload) rides along
// unchanged. If nothing takes focus within a moment the app is not installed
// and the original https link loads in the same tab. Phones keep the plain
// https link: their universal/app links already open the app without a
// request when it is installed.
const MOBILE = /Android|iPhone|iPad|iPod/i
const NOT_A_CHAT = /^(share|joinchat|addstickers|addemoji|addtheme|proxy|socks|setlanguage|login|s|c|iv|\+)$/

export function telegramDeepLink(href) {
  const m = String(href || '').match(/^https?:\/\/(?:t\.me|telegram\.me)\/([A-Za-z0-9_]+)\/?(?:\?(.*))?$/)
  if (!m || NOT_A_CHAT.test(m[1])) return null
  return `tg://resolve?domain=${m[1]}${m[2] ? '&' + m[2] : ''}`
}

export function installTelegramDeepLinks() {
  if (typeof window === 'undefined' || window.__telegramDeepLinks) return
  window.__telegramDeepLinks = true
  if (MOBILE.test(navigator.userAgent)) return

  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
    const a = e.target && e.target.closest ? e.target.closest('a[href]') : null
    if (!a) return
    const deep = telegramDeepLink(a.getAttribute('href'))
    if (!deep) return

    e.preventDefault()
    const web = a.href
    let handled = false
    const settle = () => { handled = true }
    // The app (or the browser's "open Telegram?" prompt) takes focus → no fallback.
    window.addEventListener('blur', settle, { once: true })
    document.addEventListener('visibilitychange', settle, { once: true })
    window.location.href = deep
    setTimeout(() => {
      window.removeEventListener('blur', settle)
      if (!handled && !document.hidden) window.location.href = web // same tab: a popup blocker cannot swallow it
    }, 1500)
  }, true)
}
